var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2256",
    d: "M6.12765 14.4974C4.35838 14.4974 3.47375 14.4974 2.84393 14.1197C2.43229 13.8729 2.10067 13.52 1.88664 13.1009C1.55918 12.4597 1.6472 11.6118 1.82325 9.91613C1.97021 8.50061 2.04369 7.79285 2.40505 7.27307C2.64229 6.93181 2.96318 6.6521 3.33933 6.45867C3.91225 6.16406 4.65071 6.16406 6.12765 6.16406H13.8711C15.348 6.16406 16.0865 6.16406 16.6594 6.45867C17.0355 6.6521 17.3564 6.93181 17.5937 7.27307C17.955 7.79285 18.0285 8.50061 18.1755 9.91613C18.3515 11.6118 18.4395 12.4597 18.1121 13.1009C17.898 13.52 17.5664 13.8729 17.1548 14.1197C16.525 14.4974 15.6403 14.4974 13.8711 14.4974",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 249",
    d: "M14.1654 6.16406V4.4974C14.1654 2.92605 14.1654 2.14037 13.6772 1.65222C13.1891 1.16406 12.4034 1.16406 10.832 1.16406H9.16536C7.59402 1.16406 6.80834 1.16406 6.32019 1.65222C5.83203 2.14037 5.83203 2.92605 5.83203 4.4974V6.16406",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 250",
    d: "M11.6559 12.8281L8.34146 12.8281C7.77038 12.8281 7.48484 12.8281 7.24189 12.9188C6.91796 13.0398 6.64058 13.2748 6.45386 13.5864C6.31382 13.8201 6.24457 14.1207 6.10606 14.7218C5.88964 15.661 5.78143 16.1307 5.85503 16.5072C5.95316 17.0093 6.259 17.4343 6.68413 17.6593C7.00297 17.8281 7.44913 17.8281 8.34146 17.8281L11.6559 17.8281C12.5483 17.8281 12.9944 17.8281 13.3133 17.6593C13.7384 17.4343 14.0442 17.0093 14.1424 16.5072C14.216 16.1307 14.1078 15.661 13.8913 14.7218C13.7528 14.1207 13.6836 13.8201 13.5435 13.5864C13.3568 13.2748 13.0794 13.0398 12.7555 12.9188C12.5126 12.8281 12.227 12.8281 11.6559 12.8281Z",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 9.5H15.0075",
    stroke: "#3D3D3D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.1c8874d165b181ad3d84e39af5a89ea9.svg";
export { ForwardRef as ReactComponent };